import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { CampaignsMetricsContent, CampaignsMetricsSkeleton } from './content';

export function CampaignsMetrics() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={<CampaignsMetrics.Skeleton />}>
        <CampaignsMetricsContent />
      </Suspense>
    </ErrorBoundary>
  );
}

CampaignsMetrics.Skeleton = CampaignsMetricsSkeleton;
